export const defaultLimitMb = 10

export const bytesInMb = 1048576

export const convertBytesToMb = (bytes: number): number => bytes / bytesInMb
